// AUTOGENERATED: DO NOT EDIT

import { AnimatedSprite, Spritesheet, SpritesheetData, Texture } from "pixi.js";
import img from "../../assets/img/scanner/scan-idle.png";
import { SpriteSheetJSON } from "./type";

const data: SpriteSheetJSON = {
  frames: {
    "scan-idle 0.aseprite": {
      frame: {
        x: 0,
        y: 0,
        w: 48,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 48,
        h: 32,
      },
      sourceSize: {
        w: 48,
        h: 32,
      },
      duration: 100,
    },
    "scan-idle 1.aseprite": {
      frame: {
        x: 48,
        y: 0,
        w: 48,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 48,
        h: 32,
      },
      sourceSize: {
        w: 48,
        h: 32,
      },
      duration: 100,
    },
    "scan-idle 2.aseprite": {
      frame: {
        x: 96,
        y: 0,
        w: 48,
        h: 32,
      },
      rotated: false,
      trimmed: false,
      spriteSourceSize: {
        x: 0,
        y: 0,
        w: 48,
        h: 32,
      },
      sourceSize: {
        w: 48,
        h: 32,
      },
      duration: 100,
    },
  },
  meta: {
    app: "https://www.aseprite.org/",
    version: "1.3.9.2-arm64",
    image: "scan-idle.png",
    format: "RGBA8888",
    size: {
      w: 144,
      h: 32,
    },
    scale: "1",
    frameTags: [],
    layers: [
      {
        name: "Layer 1",
        opacity: 255,
        blendMode: "normal",
      },
    ],
    slices: [],
  },
  animations: {
    anim: [
      "scan-idle 0.aseprite",
      "scan-idle 1.aseprite",
      "scan-idle 2.aseprite",
    ],
  },
};
export const scanidle = async () => {
  const texture = Texture.from(img);
  texture.source.scaleMode = "nearest";

  const spritesheet = new Spritesheet(texture, data as SpritesheetData);

  await spritesheet.parse();

  const anim = new AnimatedSprite(spritesheet.animations.anim);

  anim.width = 96;
  anim.height = 64;
  anim.anchor.set(0.5, 0.5);

  return anim;
};
